module.exports = {
  // API_URL: "http://localhost:5000",
  API_URL: "https://api.autorebalance.co",
};
